import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { EmergencyContactModel } from 'src/app/core/models/emergency-contact.model';
import { InvoluntaryChangeService } from 'src/app/involuntary-change/services/involuntary-change.service';

@Component({
  selector: 'app-emergency-contact',
  templateUrl: './emergency-contact.component.html',
  styleUrls: ['./emergency-contact.component.scss']
})
export class EmergencyContactComponent implements OnInit {

  @Input() contact: EmergencyContactModel;  // Ingress emergency contact
  @Input() submitted = false;
  @Output() econtact = new EventEmitter<EmergencyContactModel>(); // emergency contact
  form: FormGroup;

  constructor(private fb: FormBuilder, private service: InvoluntaryChangeService) {}

  ngOnInit() {
    this.buildForm();
  }

  buildForm() {
    this.form = this.fb.group({
      firstName: [!!this.contact ? this.contact.firstName : '', Validators.required],
      lastName: [!!this.contact ? this.contact.lastName : '', Validators.required],
      number: [!!this.contact ? this.contact.number : '', Validators.required],
      relationship: [!!this.contact ? this.contact.relationship : '', Validators.required],
    });
  }

  onValueChange() {
    if(this.form.enable) {
      this.econtact.emit(this.buildContact());
    }
  }

  buildContact(): EmergencyContactModel {
    return ({
      firstName: this.form.controls.firstName.value,
      lastName: this.form.controls.lastName.value,
      number: this.form.controls.number.value,
      relationship:  this.form.controls.relationship.value
    });
  }




}
